module.exports = __webpack_public_path__ + "img/lock_bg.35eb9267.png";